export const productActionTypes = {
    START_FETCHING_PRODUCTS: 'START_FETCHING_PRODUCTS',
    SUCCESS_FETCHING_PRODUCTS: 'SUCCESS_FETCHING_PRODUCTS',
    ERROR_FETCHING_PRODUCTS:'ERROR_FETCHING_PRODUCTS',
    FETCH_SINGLE_PRODUCT:'FETCH_SINGLE_PRODUCT'
}